import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Login.css';

const PasswordReset = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setError('Invalid reset token');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/password-reset/reset', { token, password });
      const data = response.data;

      if (data.success) {
        setSuccess('Password reset successful! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(data.message || 'Password reset failed');
      }
    } catch (err) {
      console.error('Password reset error:', err);
      setError('Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card password-reset-card">
        <h2>Password Reset</h2>
        <p className="subtitle">
          {token ? 'Enter your new credentials to regain access' : 'Invalid or expired reset token'}
        </p>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        {success && (
          <div className="success-message">
            <span className="success-icon">✓</span>
            {success}
          </div>
        )}
        
        {token ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                minLength="6"
                placeholder="Enter new password..."
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
                minLength="6"
                placeholder="Confirm new password..."
              />
            </div>
            
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Resetting Password...
                </>
              ) : (
                <>
                  🔐 Reset Password
                </>
              )}
            </button>
          </form>
        ) : (
          <div className="invalid-token-message">
            <span className="error-icon">⚠</span>
            <p>This reset link is invalid or has expired.</p>
            <p>Reset links are only valid for 30 minutes.</p>
          </div>
        )}
        
        <div className="toggle-form">
          <p>{token ? 'Remember your password?' : 'Need a new reset link?'}</p>
          <button 
            onClick={() => navigate('/login')} 
            className="toggle-button" 
            type="button" 
            disabled={loading}
          >
            {token ? '🔙 Back to Login' : '🔗 Request New Link'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;